const defaultUsersState = {
  activeReview: true,
  counts: {
    activeUsers: 0,
    deactivatedUsers: 0,
    totalUsers: 0
  },
  byId: {},
  isModalOpen: false,
  search: '',
  sort: {
    lastName: null,
    email: null,
    role: null,
    isLockedOnAccount: null
  },
  selectedUserId: '',
  deactivatedActiveReview: false,
  roles: []
};

export const users = (state = defaultUsersState, action) => {
  switch (action.type) {
    case 'DESELECT_USER': {
      return {
        ...state,
        selectedUserId: ''
      };
    }
    case 'LOAD_INITIAL_USERS':
    case 'LOAD_INITIAL_DEACTIVATED_USERS':
    case 'SEARCH_SORT_USERS':
    case 'REQUEST_ROLES': {
      return {
        ...state,
        ...action.payload
      };
    }
    case 'RESET_USERS': {
      return {
        ...state,
        byId: {}
      };
    }
    case 'SEARCH_USERS':
    case 'UPDATE_USER':
    case 'TOGGLE_USER_STATUS': {
      return {
        ...state,
        byId: {
          ...state.byId,
          ...action.payload.byId
        }
      };
    }
    case 'CLEAR_SEARCH_INPUT': {
      return {
        ...state,
        search: ''
      };
    }
    case 'SELECT_DEACTIVATED': {
      return {
        ...state,
        activeReview: false,
        deactivatedActiveReview: true,
        search: '',
        sort: {
          lastName: null,
          email: null,
          role: null
        }
      };
    }
    case 'SELECT_INVITATIONS': {
      return {
        ...state,
        activeReview: false,
        deactivatedActiveReview: false,
        search: '',
        sort: {
          lastName: null,
          email: null,
          role: null
        }
      };
    }
    case 'SELECT_USER': {
      return {
        ...state,
        selectedUserId: action.payload,
        isModalOpen: true
      };
    }
    case 'SELECT_USERS': {
      return {
        ...state,
        activeReview: true,
        deactivatedActiveReview: false,
        search: '',
        sort: {
          lastName: null,
          email: null,
          role: null,
          isLockedOnAccount: null
        }
      };
    }
    // AFTER UAT, REMOVE OR UNCOMMENT BASED ON FEEDBACK
    // case 'REMOVE_USER_FROM_TABLE': {
    //   return {
    //     ...state,
    //     byId: Object.keys(state.byId)
    //       .filter(id => id !== action.payload)
    //       .reduce(
    //         (byIdObj, id) => ({
    //           ...byIdObj,
    //           [id]: state.byId[id]
    //         }),
    //         {}
    //       )
    //   };
    // }
    case 'CLOSE_MODAL': {
      return {
        ...state,
        isModalOpen: false
      };
    }
    default:
      return state;
  }
};

export const usersSelectors = {
  activeReview: state => state.users.activeReview,
  deactivatedActiveReview: state => state.users.deactivatedActiveReview,
  activeUsersCount: state => state.users.counts.activeUsers,
  deactivatedUsersCount: state => state.users.counts.deactivatedUsers,
  usersByIdList: state => Object.values(state.users.byId),
  search: state => state.users.search,
  selectedUserDepartments: state =>
    state.users.byId[state.users.selectedUserId]?.accountDepartments?.find(account => {
      return account.accountNumber === state.user.get('userAccount')?.number;
    })?.departmentNumbers || [],
  selectedUserEmail: state => state.users.byId[state.users.selectedUserId]?.email,
  selectedUserName: state =>
    `${state.users.byId[state.users.selectedUserId]?.firstName} ${
      state.users.byId[state.users.selectedUserId]?.lastName
    }`,
  selectedUserRole: state => state.users.byId[state.users.selectedUserId]?.role,
  selectedUserIsActive: state => state.users.byId[state.users.selectedUserId]?.activeOnAccount,
  selectedUserLastLogin: state => state.users.byId[state.users.selectedUserId]?.lastLogin,
  selectedUserIsLocked: state => state.users.byId[state.users.selectedUserId]?.isLockedOnAccount,
  selectedUserId: state => state.users.selectedUserId,
  sort: state => state.users.sort,
  sortEntries: state => Object.entries(state.users.sort),
  totalUsers: state => state.users.counts.totalUsers,
  isModalOpen: state => state.users.isModalOpen,
  roles: state => state.users.roles
};
